import { Component, Input, ContentChild, ContentChildren, QueryList, EventEmitter, Output, HostBinding } from '@angular/core';
import { BpTabDirective } from './tab.directive';

export type TabAppearance = 'none' | 'default' | 'pill';
export class TabSelectEvent {
    index: number;
    tab: BpTabDirective;
}

@Component({
    selector: 'bp-tabs',
    exportAs: 'bpTabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.scss'],
})
export class BpTabsComponent {
    @ContentChildren(BpTabDirective) tabs: QueryList<BpTabDirective>;
    @Input() selectedIndex = 0;
    @Input() disabled = false;
    @Input() fade = true;
    @Input() appearance: TabAppearance = 'default';
    @Input() vertical = false;
    @Input() contentCssClass: string;
    @Output() tabSelect = new EventEmitter<TabSelectEvent>();

    @HostBinding('class') public get _class() {
        let cls = 'bp-tabs';
        if (this.vertical) {
            cls += 'bp-tabs-vertical';
        }

        return cls;
    }

    public _onTabClick(tab: BpTabDirective, index: number) {
        if (tab.disabled || this.disabled) {
            return;
        }

        this.selectedIndex = index;
        const arg = new TabSelectEvent();
        arg.index = index;
        arg.tab = tab;
        this.tabSelect.emit(arg);
    }
}
